<template>
  <div class="order-new">
    <!-- 客户信息 -->
    <div class="subtitle" @click="onShowCustomerInfo">购买人信息</div>
    <ul class="ca-info" v-show="showCustomerInfo">
      <li>
        姓名
        <span class="inter">
          <input type="text" readonly v-model.trim="order.name" />
        </span>
      </li>
      <li>
        手机号码
        <span class="inter">
          <input
            type="tel"
            maxlength="11"
            readonly
            style="ime-mode:disabled"
            v-model.trim="order.mobile"
          />
        </span>
      </li>
      <li>
        回执编号
        <span class="red"></span>
        <span class="inter">
          <input type="text" maxlength="15" readonly v-model="survey_code" />
        </span>
      </li>
    </ul>
    <!-- 购买信息 -->
    <div class="subtitle">
      套餐信息
      <span>（*项为必填项）</span>
    </div>
    <ul class="ca-info">
      <li @click="onPickerClick">
        套餐名称
        <span class="red">*</span>
        <span class="select">></span>
        <span class="selected">
          <input type="text" readonly v-model="selectedPkgTitle" style="width:130px;" />
        </span>
      </li>
      <li v-show="is_trade_no" style="line-height: 50px; padding: 0;">
        外部商城订单编号
        <span class="red">*</span>
        <span class="inter">
          <input type="tel" v-model.trim="trade_no" style="height: 22px; width: 160px;" />
        </span>
      </li>
      <li @click="onPriceClick">
        套餐价格
        <span class="red">*</span>
        <span class="select">></span>
        <span class="selected">
          <input type="text" readonly v-model="selectedPrice" style="width:100px;" />
        </span>
      </li>
      <li @click="onPeriodClick">
        服务时长
        <span class="red">*</span>
        <span class="select">></span>
        <span class="selected">
          <input type="text" readonly v-model="selectedPeriod" style="width:100px;" />
        </span>
      </li>
      <li v-show="is_dikou">
        可用于抵扣的金额
        <span class="selected">{{ order.dikou_valid_amount || '0' }}元</span>
      </li>
      <li v-show="is_dikou">
        本订单抵扣金额
        <span class="selected">
          <input
            ref="txtDikouAmount"
            readonly
            type="tel"
            placeholder="请输入本订单抵扣金额"
            v-model.number="order.dikou_amount"
            style="width:150px;"
            @focus="onDikouAmountFocus"
            @change="onDikouAmountChange"
            @blur="onDikouAmountChange"
          />
        </span>
      </li>
      <li>
        本订单应付金额
        <span class="selected">
          <input type="tel" v-model="payPrice" readonly style="width:150px;" />
        </span>
      </li>
    </ul>
    <div class="actions mt-50">
      <mt-button type="primary" @click="onSubmitClick">提交</mt-button>
      <p
        class="mt-50"
        style="font-size:13px;padding: 5px 20px"
      >温馨提示：订单创建过程中遇到问题，可在企业号【我的客户】栏目中直接发送问题消息到后台，值班技术支持会尽快给您回复。</p>
    </div>
    <pd-select-box ref="pdSelect" v-on:change="onPkgChange" :customMobile="order.mobile"></pd-select-box>
    <price-select-box ref="priceSelect" v-on:change="onPriceChange"></price-select-box>
    <period-select-box ref="periodSelect" v-on:change="onPeriodChange"></period-select-box>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PdSelectBox from "@/components/PdSelectBox";
import PriceSelectBox from "@/components/PriceSelectBox";
import PeriodSelectBox from "@/components/PeriodSelectBox";
import WxIdGuide from "@/components/WxIdGuide";
import { Button, MessageBox } from "mint-ui";

export default {
  name: "OrderNewPkg",
  components: {
    PdSelectBox,
    PriceSelectBox,
    PeriodSelectBox,
    WxIdGuide,
    "mt-button": Button
  },
  data: () => ({
    product: {},
    prod_pkg: {},
    showCustomerInfo: true,
    is_extend: false,
    is_dikou: false,
    selectedPkgTitle: "请选择",
    selectedPrice: "0元",
    selectedPeriod: "0个月",
    payPrice: 0,
    is_trade_no: false,
    trade_no: ""
  }),
  computed: {
    ...mapGetters({
      qyh: "getQyh",
      order: "getNewOrder",
      customer: "getNewCustomer"
    }),
    survey_code() {
      if (!this.order.survey_code || this.order.survey_code.length === 0) {
        return "未填写";
      }
      return this.order.survey_code;
    }
  },
  created: function() {},
  mounted: function() {
    console.log(this.order)
    console.log(this.customer)
    this.setPageTitle("选择订单套餐");
  },
  methods: {
    initFormField() {
      console.log("dikou | extend: ", this.is_dikou, this.is_extend);
      this.selectedPkgTitle = this.order.product_pkg_title || "请选择";
      this.selectedPrice = (this.order.order_price || "0") + "元";
      this.selectedPeriod = (this.order.service_period || "0") + (this.order.granularity === 2 ? '天' : '个月');
      this.payPrice = this.order.order_price || 0;
    },
    onDikouAmountFocus() {
      if (!this.order.dikou_amount || this.order.dikou_amount === 0) {
        this.$refs.txtDikouAmount.value = "";
      }
    },
    onDikouAmountChange() {
      if (!this.is_dikou) {
        return;
      }
      if (!this.order.dikou_amount) {
        this.order.dikou_amount = 0;
      }
      if (
        parseInt(this.order.dikou_amount) < parseFloat(this.order.dikou_amount)
      ) {
        this.toast("为了方便计算，本订单抵扣金额建议输入整数, 请重新修改");
        return;
      }
      if (parseFloat(this.order.dikou_amount) >= this.order.order_price) {
        this.toast("本订单抵扣金额要小于套餐价格, 请重新修改");
        return;
      }
      this.payPrice = this.order.order_price - this.order.dikou_amount;
      this.order.service_period = this.prod_pkg.package_service;
      this.order.granularity = this.prod_pkg.granularity ? this.prod_pkg.granularity : 1;
    },
    onShowCustomerInfo() {
      this.showCustomerInfo = !this.showCustomerInfo;
    },
    onSubmitClick(event) {
      this.onCreateOrder(event);
    },
    onValidProductForm() {
      if (!this.product || !this.product.product_id) {
        this.toast("请选择套餐");
        return false;
      }
      if (!this.prod_pkg || !this.prod_pkg.package_code) {
        this.toast("请选择套餐");
        return false;
      }
      if (this.is_trade_no && this.trade_no === "") {
        this.toast("请输入外部商城订单编号");
        return false;
      }
      if (this.order.dikou_amount && parseFloat(this.order.dikou_amount) > 0) {
        if (parseInt(this.order.dikou_amount) < this.order.dikou_amount) {
          this.toast("为了方便计算，本订单抵扣金额建议输入整数, 请重新修改");
          return;
        }
        if (
          parseFloat(this.order.dikou_amount) >
          parseFloat(this.order.dikou_valid_amount)
        ) {
          this.toast("本订单抵扣金额已超过客户可用金额, 请重新修改");
          return false;
        }
        if (parseFloat(this.order.dikou_amount) >= this.order.order_price) {
          this.toast("本订单抵扣金额要小于套餐价格, 请重新修改");
          return false;
        }
      } else {
        this.order.dikou_amount = 0;
      }
      return true;
    },
    onCreateOrder(event) {
      if (!this.onValidProductForm()) {
        return;
      }
      let self = this;
      if (this.order.dikou_valid_amount > 0 && this.order.dikou_amount === 0) {
        MessageBox.confirm("您尚未输入本订单抵扣金额，确认提交？").then(
          action => {
            if (action === "confirm") {
              self.onSumiteOrder();
            }
          },
          action => {}
        );
      } else {
        self.onSumiteOrder();
      }
    },
    onSumiteOrder() {
      let self = this;
      self.order.trade_no = self.is_trade_no ? self.trade_no : "";
      console.log("new order", self.order);
      self.loading("正在保存");
      self.$http.post("/api/orders", self.order).then(
        response => {
          self.loadingHide();
          console.log(response);
          var rs = response.body;
          if (rs.code === 0) {
            self.$store.dispatch("clearNewOrder", {});
            self.$router.replace("/orders/" + rs.data.order_no + "/success");
          } else {
            // 显示文字
            self.toast(rs.message);
          }
        },
        response => {
          // error callback
          console.log(response);
          self.handleHttpError(response);
        }
      );
    },
    onPickerClick(event) {
      this.$refs.pdSelect.showPicker();
    },
    onPriceClick(event) {
      if (!this.prod_pkg || !this.prod_pkg.sell_price) {
        return;
      }
      if (this.prod_pkg.sell_price.length <= 1) {
        this.onPriceChange(this.prod_pkg.sell_price)
        return;
      }

      this.$refs.priceSelect.showPicker();
    },
    onPeriodClick(event) {
      if (!this.prod_pkg || !this.prod_pkg.sell_periods) {
        return;
      }
      if (this.prod_pkg.sell_periods.length <= 1) {
        return;
      }
      if (
        this.prod_pkg.allow_extend === "1" &&
        this.order.order_price >= this.order.product_pkg_price
      ) {
        this.$refs.periodSelect.showPicker();
      }
    },
    onPkgChange(value) {
      console.log(value);
      this.product = value[0];
      this.prod_pkg = value[1];
      this.selectedPrice = this.prod_pkg.package_price;

      this.order.product_id = this.product.product_id;
      this.order.product_title = this.product.product_name;
      this.order.product_pkg_code = this.prod_pkg.package_code;
      this.order.product_pkg_title = this.prod_pkg.package_name;
      this.order.product_pkg_price = parseFloat(this.prod_pkg.package_price);
      this.order.product_risk_rank = this.product.risk_rank;
      this.order.service_period = this.prod_pkg.package_service;
      this.order.granularity = this.prod_pkg.granularity ? this.prod_pkg.granularity : 1;
      this.order.order_price = parseFloat(this.prod_pkg.package_price);
      this.order.dikou_valid_amount = 0;
      this.order.dikou_amount = 0;
      this.is_dikou = false;
      this.is_extend = false;

      this.order.third_mall = this.prod_pkg.third_mall || "";
      this.is_trade_no = this.prod_pkg.third_mall !== "";

      this.initFormField();
      if (this.customer.dikou) {
        for (var i = 0; i < this.customer.dikou.length; i++) {
          let t = this.customer.dikou[i];
          console.log(
            "dikou: ",
            t,
            t.package_code === this.order.product_pkg_code
          );
          if (t.package_code === this.order.product_pkg_code) {
            this.order.dikou_valid_amount = parseInt(t["dikou_amount"]);
            this.order.dikou_amount = parseInt(t["dikou_amount"]);
            this.is_dikou = this.order.dikou_amount > 0;
            this.onDikouAmountChange();
            break;
          }
        }
      } else {
        console.log("customer", this.customer);
        console.log("dikou", this.customer["dikou"]);
        this.order.dikou_valid_amount = 0;
      }
      console.log("newOrder: ", this.order);
      if (this.prod_pkg.sell_price.length <= 1) {
        this.onPriceChange(this.prod_pkg.sell_price)
      } else {
        this.$refs.priceSelect.setPriceData();
        let it = null;
        let self = this;
        it = setTimeout(function() {
          self.onPriceClick();
          clearTimeout(it);
        }, 500);
      }
      this.$refs.periodSelect.setSoltData();
    },
    onPriceChange(value) {
      this.order.order_price = parseFloat(value[0]);
      if (this.order.order_price >= this.order.product_pkg_price) {
        this.$refs.periodSelect.setSoltData();
        // this.order.dikou_amount = 0
        this.is_dikou =
          this.prod_pkg.allow_dikou === "1" &&
          parseFloat(this.order.dikou_valid_amount) > 0;
        this.is_extend = this.prod_pkg.allow_extend === "1";
        let it = null;
        let self = this;
        it = setTimeout(function() {
          self.onPeriodClick();
          clearTimeout(it);
        }, 500);
      } else {
        this.order.service_period = this.prod_pkg.package_service;
        this.order.granularity = this.prod_pkg.granularity ? this.prod_pkg.granularity : 1;
        if (this.prod_pkg.allow_dikou === "1") {
          // if (parseFloat(this.order.dikou_amount) >= this.order.order_price) {
          // 	this.order.dikou_amount = 0
          // }
          this.is_dikou = parseFloat(this.order.dikou_valid_amount) > 0;
          this.is_extend = false;
        } else {
          this.is_dikou = false;
          this.is_extend = false;
          // this.order.dikou_amount = 0
        }
      }
      this.initFormField();
      this.onDikouAmountChange();
      console.log("newOrder: ", this.order);
    },
    onPeriodChange(value) {
      this.order.service_period = parseInt(value[0]);
      // this.order.dikou_amount = 0
      this.is_extend =
        this.order.service_period > parseInt(this.prod_pkg.package_service);
      this.is_dikou =
        this.prod_pkg.allow_dikou === "1" &&
        !this.is_extend &&
        parseFloat(this.order.dikou_valid_amount) > 0;
      this.initFormField();
      console.log("newOrder: ", this.order);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/OrderNewPkg.vue